module.exports = __webpack_public_path__ + "static/media/pic40.55a02717.jpg";